function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * This file is the entry point to our researcher app. This file should only reference a routes
 * component in each module (prepay, order, referral-rewards, etc...) as well as
 * any application-wide configurations / etc
 */

// Base imports
import './styles';
import 'shared/helper/airbrake';
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { dispatchCachedActionCreators } from 'shared/helper/redux-cache';
import { parseQueryParams, getLanguage } from 'shared/helper/link-helper';
import { localStorage, storage } from 'shared/helper/storage';
import { storeWithData } from 'shared/helper/store';
import { ServerUnavailable } from 'shared/components/ServerUnavailable';
import * as application from './application/actions';
import * as domainPaymentMethod from './domain/transaction/payment-method';
import * as domainService from './domain/product/service';
import ResearcherRoutes from './Routes';
import rootReducer from './reducer';
import { actions as applicationActions } from './application';
import { actions as userActions } from './user';

// App setup
var store = storeWithData(rootReducer, {
  application: application,
  storage: storage
});
var queryParams = parseQueryParams(window.location.search);
if (queryParams.logout) {
  store.dispatch(userActions.logout());
}

// Run any cached action creators
dispatchCachedActionCreators(store);
export var actions = {
  updateSiteLanguage: applicationActions.updateSiteLanguage
};
export var domain = {
  paymentMethod: domainPaymentMethod,
  service: domainService
};

// Convert class component to functional component using hooks
export var ResearcherProvider = function ResearcherProvider(_ref) {
  var children = _ref.children,
    config = _ref.config,
    translationContext = _ref.translationContext;
  // Use useState to manage the ready state
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    ready = _useState2[0],
    setReady = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    troubleLoadingPage = _useState4[0],
    setTroubleLoadingPage = _useState4[1];

  // Use useEffect to replicate the componentDidMount lifecycle method
  useEffect(function () {
    var hrefLanguage = getLanguage(window.location.href, true);
    var maxRetries = 10;
    var retryCount = 0;
    var shouldUpdateSiteLanguage = !localStorage.get('language');
    var _loadLanguage = function loadLanguage() {
      store.dispatch(applicationActions.loadSiteLanguage(hrefLanguage, translationContext)).catch(function () {
        if (retryCount < maxRetries) {
          retryCount += 1;
          _loadLanguage();
        } else {
          shouldUpdateSiteLanguage = true;
        }
      });
    };
    var _loadApplication = function loadApplication() {
      store.dispatch(applicationActions.loadApplication(queryParams)).then(function (json) {
        // This is application data that is globally accessible. Ideally, these
        // would make their way into our containers and components instead of
        // being globally available
        window.AppData = window.AppData || {};
        window.AppData = {
          // Used by the feature helper
          feature: json.application.feature
          // Used by airbrake
          // airbrakeUser: json.user
          //     ? { email: json.user.email, id: json.user.identity, name: json.user.fullName }
          //     : {},
        };

        // If we get here, it means we didn't have a local storage variable set, in which case
        // we need to update our language to match what is coming from the server
        if (shouldUpdateSiteLanguage) {
          store.dispatch(applicationActions.updateSiteLanguage(hrefLanguage || json.application.siteLanguage, translationContext));
        }
        if (json.user) {
          store.dispatch(userActions.loadUser(json.user));
        } else {
          store.dispatch(userActions.finishLoadingUser());
        }

        // After we've injected our base configuration and loaded the application, we're ready to start displaying things
        setReady(true); // Update the ready state using the setReady function
      }).catch(function () {
        if (retryCount < maxRetries) {
          retryCount += 1;
          _loadApplication();
        } else {
          setReady(true);
          setTroubleLoadingPage(true);
        }
      });
    };
    store.dispatch(applicationActions.injectConfiguration(config));
    _loadLanguage();
    retryCount = 0;
    _loadApplication();
  }, []); // Empty dependency array to ensure the effect runs only once on mount

  if (!ready) {
    return /*#__PURE__*/React.createElement("div", {
      className: "static-loading-message"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-spinner-scale",
      spin: true
    }));
  }
  if (troubleLoadingPage) {
    return /*#__PURE__*/React.createElement(ServerUnavailable, null);
  }
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(BrowserRouter, null, children));
};
export var ResearcherApp = function ResearcherApp() {
  return /*#__PURE__*/React.createElement(ResearcherRoutes, null);
};